// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"aO","newsItemBox":"aO","img-box":"aP","imgBox":"aP","img-mask-box":"aQ","imgMaskBox":"aQ"};